export default __webpack_public_path__ + "static/about-ad78093bb274ce22fa31fa56b749708b.png";